var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E60000",
    d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24",
    transform: "translate(-90 -12) translate(80) translate(10 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.19 37.383c-6.594.022-13.454-5.606-13.484-14.643-.02-5.977 3.204-11.73 7.325-15.142 4.02-3.329 9.528-5.465 14.522-5.482.643-.002 1.316.052 1.727.191-4.367.906-7.842 4.97-7.827 9.581 0 .153.014.315.03.391 7.307 1.78 10.624 6.19 10.645 12.29.02 6.102-4.797 12.787-12.938 12.814",
    transform: "translate(-90 -12) translate(80) translate(10 12)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.d6712b04fee112d05ba71d52305e7747.svg";